import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_dialog_log_detail_component } from './c_dialog_log_detail_component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [c_dialog_log_detail_component],
  exports: [ c_dialog_log_detail_component]
})
export class c_dialog_log_detail_module { }
